export const onlyUniqueArray = (value, index, self) => self.indexOf(value) === index;
